module.exports = __webpack_public_path__ + "img/inventar.5216a2de.svg";